import { useEffectOnce } from 'react-use';
import { useRouter } from 'next/router';
import { useAuth } from '@zep/auth';
import { baseUrl } from '@zep/common/routes';

/**
 * iframe을 통한 로그인 완료인 경우 부모레벨로 이벤트 전달
 * @constructor
 */
export const SigninFinishPageView = () => {
  const {
    isAuthenticated
  } = useAuth();
  const router = useRouter();
  useEffectOnce(() => {
    if (!isAuthenticated) {
      router.replace('/');
      return;
    }
    const baseURL = baseUrl;
    if (window.top !== window.self) {
      window.parent.postMessage({
        zepSystem: true,
        type: 'SIGNIN_SUCCESS'
      }, baseURL);
    }
    router.replace('/home/spaces');
  });
  return <></>;
};